import {z} from 'zod';

const MIN_SLIDE_NAME_LENGTH = 1;
export const MAX_SLIDE_NAME_LENGTH = 100;

export const slideNameValidator = z
    .string()
    .trim()
    .min(MIN_SLIDE_NAME_LENGTH, 'designSidepanel.tooShortSlideName')
    .max(MAX_SLIDE_NAME_LENGTH, 'designSidepanel.tooLongSlideName');
